/** הזמנות גמרא — תוויות ועזרים משותפים לשני העיצובים */
export const FRAME_OPTIONS = [
  { value: 'daf_yomi', label: 'דף היומי' },
  { value: 'shinun', label: 'דף השינון' },
  { value: 'meshannim', label: 'משננים' },
];
export const FRAME_LABELS = Object.fromEntries(FRAME_OPTIONS.map((f) => [f.value, f.label]));

export const AUDIENCE_OPTIONS = [
  { value: 'examinees', label: 'לנבחנים בלבד', hint: 'מזמינים רק אחרי ביצוע המבחן (בסיום המבחן בטלפון ובאתר)' },
  { value: 'all', label: 'פתוח לכולם', hint: 'גם בלי מבחן — מקש 4 בתפריט דף היומי (1/4) / דף השינון (2/4)' },
];
export const AUDIENCE_LABELS = Object.fromEntries(AUDIENCE_OPTIONS.map((a) => [a.value, a.label]));

export const SOURCE_LABELS = {
  ivr_exam: 'טלפון — סיום מבחן',
  ivr_menu: 'טלפון — שלוחת הזמנה',
  web: 'אתר',
  admin: 'ידני',
};

export const ORDER_STATUS = {
  ordered: { label: 'הוזמן', tone: 'primary' },
  delivered: { label: 'נמסר', tone: 'success' },
  cancelled: { label: 'בוטל', tone: 'neutral' },
};

export const CAMPAIGN_STATUS = {
  draft: { label: 'טיוטה', tone: 'neutral' },
  open: { label: 'פתוח להזמנה', tone: 'success' },
  closed: { label: 'סגור', tone: 'warning' },
};

const IL_DAY = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Jerusalem', year: 'numeric', month: '2-digit', day: '2-digit',
});

/** תאריך שמור → YYYY-MM-DD (יום בשעון ישראל) לשדה date */
export function toDayInput(value) {
  return value ? IL_DAY.format(new Date(value)) : '';
}

export function formatDay(value) {
  return value ? new Date(value).toLocaleDateString('he-IL', { timeZone: 'Asia/Jerusalem' }) : '';
}

export const emptyCampaignForm = () => ({
  title: '', frames: ['daf_yomi'], audience: 'examinees', opensAt: '', closesAt: '', notes: '',
});

export function campaignToForm(c) {
  return {
    title: c.title || '',
    frames: c.frames?.length ? c.frames : ['daf_yomi'],
    audience: c.audience || 'examinees',
    opensAt: toDayInput(c.opensAt),
    closesAt: toDayInput(c.closesAt),
    notes: c.notes || '',
  };
}

/** סטטוס בפועל: כרך "פתוח" שמחוץ לחלון התאריכים מוצג כממתין / נסגר */
export function campaignStateLabel(c) {
  if (c.status !== 'open') return CAMPAIGN_STATUS[c.status] || CAMPAIGN_STATUS.draft;
  if (c.isOpenNow) return CAMPAIGN_STATUS.open;
  if (c.opensAt && new Date(c.opensAt) > new Date()) return { label: `ייפתח ב-${formatDay(c.opensAt)}`, tone: 'info' };
  return { label: 'הסתיים מועד ההזמנה', tone: 'warning' };
}

export function downloadBlob(data, filename) {
  const url = URL.createObjectURL(new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
